import type { DocMigration } from "../docMigration";

const RECTANGULAR_FRAMING_COMPONENT_TYPES = new Set(["COMPOSITE_LUMBER", "TRUSS", "CUSTOM"]);

function migrateFramingComponentDepthWidth(component: Record<string, unknown>): void {
  if (!RECTANGULAR_FRAMING_COMPONENT_TYPES.has(component.type as string)) {
    return;
  }

  if ("depth" in component && !("height" in component)) {
    return;
  }

  if ("width" in component && component.width !== undefined) {
    component.depth = component.width;
    delete component.width;
  }

  if ("height" in component && component.height !== undefined) {
    component.width = component.height;
    delete component.height;
  }
}

const migration: DocMigration = {
  id: "20260618_framing_component_depth_width",
  description:
    "Rename FRAMING_COMPONENT width->depth and height->width on COMPOSITE_LUMBER, TRUSS, and CUSTOM entities",
  apply(json: any): any {
    for (const id in json.framingComponents ?? {}) {
      migrateFramingComponentDepthWidth(json.framingComponents[id]);
    }

    return json;
  },
};

export default migration;
